import { DialogContent, Grid } from "@mui/material";
import { useEffect, useState, useRef } from "react";
import axios from "axios";
import BASE_URL from "../../../../constants/baseUrls";
import autoAnimate from "@formkit/auto-animate";
import { useTranslation } from "react-i18next";

//import constants
import { BREAKPOINT, IS_MOBILE, WIDTH } from "../../../../constants/breakpoints";

//import general components
import { BaseButton } from "../../../../components/common/base-button/base-button";
import BaseDialog from "../../../common/base-dialog/base-dialog";

//import view components
import BankCardList from "./bank-card-list";
import BankCardForm from "./bank-card-form";

//importimages and icons
import { AddSquare, CloseSquare } from "iconsax-react";

//import styles
import "./bank-account-information.scss";

function BankAccountInformation() {
    //general variables
    const { t } = useTranslation();
    const accessToken = localStorage.getItem("accessToken");
    const parent = useRef(null);

    //set animation
    useEffect(() => {
        if (WIDTH > BREAKPOINT) {
            parent.current && autoAnimate(parent.current);
        }
    }, [parent]);

    //handle show form
    const [isCardList, setIsCardList] = useState(true);
    const handleFormChange = () => {
        setIsCardList(!isCardList);
    };

    //request to get bank card list
    const [cardList, setCardList] = useState([]);
    const getCardList = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/account/user/bank_account/list/`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            setCardList(response.data.results);
        } catch (error) {}
    };

    useEffect(() => {
        if (accessToken && isCardList) {
            getCardList();
        }
    }, [isCardList]);

    return (
        <Grid className="bank-account-information" container item xs={12} rowGap={{ xs: 0, md: 4 }} justifyContent="center" ref={parent}>
            <Grid className="bank-account-information__title-box" container item xs={12} justifyContent="space-between" alignItems="center">
                <span className="bank-account-information__title">{t("bankAccountInformation")}</span>

                <Grid className="bank-account-information__add-card" container item xs={12} md={2.5} justifyContent="flex-end">
                    {isCardList ? (
                        <BaseButton
                            text={t("addNewCard")}
                            color="outline-secondary"
                            size="medium"
                            radius="radius-10"
                            handleClick={handleFormChange}
                            rightIcon={<AddSquare color="var(--secondary-color)" />}
                        />
                    ) : (
                        <CloseSquare size="32" color="var(--secondary-color)" onClick={handleFormChange} cursor="pointer" />
                    )}
                </Grid>
            </Grid>
            {isCardList ? (
                <BankCardList cardList={cardList} getCardList={getCardList} />
            ) : (
                <>
                    {IS_MOBILE ? (
                        <BaseDialog title={t("addNewCard")} open={!isCardList} handleClose={handleFormChange} maxWidth="lg" top="40%" icon="close">
                            <DialogContent>
                                <BankCardForm setIsCardList={setIsCardList} />
                            </DialogContent>
                        </BaseDialog>
                    ) : (
                        <BankCardForm setIsCardList={setIsCardList} />
                    )}
                </>
            )}
        </Grid>
    );
}

export default BankAccountInformation;
